<!-- Product Image Slideshow JScode ============================================================================= -->
function initPdBanner({
  root,
  imageData
}) {
  if (!root || !imageData) return;
  const slideImage = root.querySelector(".pd-slideshow");
  const slidePagi  = root.querySelector(".pd-pagination");
  if (!slideImage) {
    console.warn("Missing slideshow:", root);
    return;
  }

  let currentIdx = 1;
  let intId;
  let isAni = false;

  // ===== 以下基本保持你原逻辑，只用局部变量 =====

  function createPicEl(imgItem) {
    const img = document.createElement("img");
    img.className = "pd-slide-img";
    img.src = imgItem.image;

    return img;
  }

  function createSlideEl(imgItem) {
    const slide = document.createElement("div");
    slide.className = "pd-slide";
    slide.appendChild(createPicEl(imgItem));
    return slide;
  }

  function createPdSlides() {
    slideImage.innerHTML = "";

    slideImage.appendChild(createSlideEl(imageData[imageData.length - 1]));
    imageData.forEach(item => slideImage.appendChild(createSlideEl(item)));
    slideImage.appendChild(createSlideEl(imageData[0]));

    slideImage.style.transform = `translateX(-${currentIdx * 100}%)`;
  }

  function setupPagi() {
    if (!slidePagi) { return; }
    slidePagi.innerHTML = "";
    imageData.forEach((_, i) => {
      const dot = document.createElement("div");
      dot.className = "pd-dot";
      if (i === 0) dot.classList.add("active");
      dot.onclick = () => go2Slide(i + 1);
      slidePagi.appendChild(dot);
    });
  }

  function updatePagi() {
    const dots = slidePagi.querySelectorAll(".pd-dot");
    if (dots.length === 0) { return; }
    dots.forEach(d => d.classList.remove("active"));
    dots[(currentIdx - 1 + imageData.length) % imageData.length]
      .classList.add("active");
  }

  function go2Slide(i) {
    if (isAni) return;
    currentIdx = i;
    aniSlide();
  }

  function aniSlide() {
    if (!slideImage) { return; }
    isAni = true;
    slideImage.style.transition = "transform .5s ease-in-out";
    slideImage.style.transform = `translateX(-${currentIdx * 100}%)`;
    updatePagi();
    resetAtPlay();
  }

  function next() { if (!isAni) { currentIdx++; aniSlide(); } }
  function prev() { if (!isAni) { currentIdx--; aniSlide(); } }

  function handleTranEnd() {
    if (currentIdx === 0) {
      slideImage.style.transition = "none";
      currentIdx = imageData.length;
    }
    if (currentIdx === imageData.length + 1) {
      slideImage.style.transition = "none";
      currentIdx = 1;
    }
    slideImage.style.transform = `translateX(-${currentIdx * 100}%)`;
    isAni = false;
  }

  function startAtPlay() {
    intId = setInterval(next, 8000);
  }

  function resetAtPlay() {
    clearInterval(intId);
    startAtPlay();
  }

  function addSwipe() {
    let startX = 0, endX = 0, isMouseDown = false, mouseStartX = 0;

    slideImage.addEventListener("touchstart", e => startX = e.touches[0].clientX);
    slideImage.addEventListener("touchend", e => {
      endX = e.changedTouches[0].clientX;
      const delta = endX - startX;
      if (Math.abs(delta) > 50) delta > 0 ? prev() : next();
    });

    slideImage.addEventListener("mousedown", e => { isMouseDown = true; mouseStartX = e.clientX; });
    document.addEventListener("mouseup", e => {
      if (!isMouseDown) return;
      isMouseDown = false;
      const delta = e.clientX - mouseStartX;
      if (Math.abs(delta) > 50) delta > 0 ? prev() : next();
    });
  }

  slideImage.addEventListener("transitionend", handleTranEnd);

  createPdSlides();

  setupPagi();
  updatePagi();
  addSwipe();
  startAtPlay();
}
<!-- Product Image Slideshow JScode ============================================================================= -->

function invertColor(color) {
  // 去掉 # 符号
  let hex = color.replace('#', '');

  // 处理 3 位简写：#fff → ffffff
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  // 转数字 → 反转 → 转回16进制
  const inverted = (0xffffff - parseInt(hex, 16)).toString(16);
  
  // 补零并返回带 # 的颜色
  return '#' + inverted.padStart(6, '0');
}

function smartInvert(color) {
  let hex = color.replace('#', '');
  if (hex.length === 3) hex = hex.split('').map(c => c+c).join('');

  const r = parseInt(hex.substr(0,2),16);
  const g = parseInt(hex.substr(2,2),16);
  const b = parseInt(hex.substr(4,2),16);

  // 计算亮度
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  
  return brightness > 128 ? '#000000' : '#ffffff';
}